import { MarkupDasharrayType, MarkupLinecapType } from '@meitu/saas-editor-core/es/version-types';

// 画笔类型列表
export const dasharrayList = [
    { value: MarkupDasharrayType.Solid, linecap: MarkupLinecapType.Square },
    { value: MarkupDasharrayType.Solid, linecap: MarkupLinecapType.Round },
    { value: MarkupDasharrayType.Square, linecap: MarkupLinecapType.Square },
    { value: MarkupDasharrayType.Dot, linecap: MarkupLinecapType.Round },
    { value: MarkupDasharrayType.Dashed, linecap: MarkupLinecapType.Round },
];
